import styles from './ProjectFlow.module.scss'

interface FlowList {
  src: string
  alt: string
  title: string
  text: string
}

const flowLists: FlowList[] = [
  {
    src: '/images/lp2/06_flow/flow_1.png',
    alt: 'お問い合わせ',
    title: 'お問い合わせ',
    text: 'まずはお気軽にお問い合わせください。',
  },
  {
    src: '/images/lp2/06_flow/flow_2.png',
    alt: 'ヒアリング',
    title: 'ヒアリング',
    text: '抱えている課題やご要望について詳しくお話を伺います。',
  },
  {
    src: '/images/lp2/06_flow/flow_3.png',
    alt: 'ご提案',
    title: 'ご提案',
    text: 'お客さまの要望にぴったりのご提案をさせていただきます。',
  },
  {
    src: '/images/lp2/06_flow/flow_4.png',
    alt: 'ご契約',
    title: 'ご契約',
    text: '提案に合意いただけたら、ご契約手続きを行います。',
  },
  {
    src: '/images/lp2/06_flow/flow_5.png',
    alt: '開始',
    title: '開始',
    text: 'プロジェクトに合ったメンバーでチームを編成し、キックオフを行います。',
  },
]

const ProjectFlow: React.FC = () => {
  const flowList = flowLists.map(({ src, alt, title, text }) => (
    <div className={styles.steps} key={title}>
      <div className={styles.step}>
        <img className={styles.img} src={src} alt={alt} />
      </div>
      <div className={styles.textWrapper}>
        <p className={styles.stepTitle}>{title}</p>
        <p className={styles.text}>{text}</p>
      </div>
    </div>
  ))
  return (
    <>
      <section className={styles.projectFlow}>
        <p className={styles.title}>プロジェクト開始までの流れ</p>
        <div className={styles.flowList}>{flowList}</div>
      </section>
    </>
  )
}

export default ProjectFlow
